import { html, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export function stepIntro(
	title: string,
	text: string
): TemplateResult {
	return html`
		<h2>${unsafeHTML( title )}</h2>
		${unsafeHTML( text )}
	`;
}
